import axios from 'axios';

const API_URL = '/api/auth';

export interface CurrentUser {
  username: string;
  nickname?: string | null;
}

export const login = async (username: string, password: string) => {
  const response = await axios.post(`${API_URL}/login`, { username, password }, { withCredentials: true });
  return response.data;
};

export const refreshAccessToken = async () => {
  const response = await axios.post(`${API_URL}/refresh`, null, { withCredentials: true });
  return response.data;
};

export const logout = async () => {
  await axios.post(`${API_URL}/logout`, null, { withCredentials: true });
};

export const getCurrentUser = async (token: string) => {
  const response = await axios.get(`${API_URL}/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data as CurrentUser;
};
